<template>
    <v-container class="pa-1" fluid grid-list-xs>
        <v-layout row="row" wrap="wrap">
            <v-flex v-for="(starter, index) in starters" :key="starter.id" xs12 :xl6="(index+1) === starters.length ? starters.length % 2 === 0 : starters.length > 1">
                <v-card height="100%">
                    <v-card-title primary-title="primary-title">
                        <v-layout row wrap>
                            <v-flex xs12>
                                <div class="headline left" v-text="starter.name"></div>
                                <v-btn class="right mt-0 hidden-xs-only" outline v-show="!starter.add_registration" :disabled="starter.loading" @click="$set(starter, 'add_registration',  true)">
                                    <v-icon>add</v-icon>{{ $t('add_registration') }}
                                </v-btn>
                                <v-tooltip bottom>
                                    <v-btn class="right mt-0" flat fab outline slot="activator" v-show="starter.add_registration" :disabled="starter.loading" @click="$set(starter, 'add_registration',  false)">
                                        <v-icon>close</v-icon>
                                    </v-btn><span>Meldung abbrechen</span></v-tooltip>
                            </v-flex>
                            <v-flex class="hidden-sm-and-up" xs12>
                                <v-btn class="right mt-0" outline block v-show="!starter.add_registration" :disabled="starter.loading" @click="$set(starter, 'add_registration',  true)">
                                    <v-icon>add</v-icon>{{ $t('add_registration') }}</v-btn>
                            </v-flex>
                            <v-flex xs12 v-show="!starter.add_registration" v-if="starter.starter_registrations.length > 0">
                                <item-list :items="starter.starter_registrations" :data-table-config="dataTableConfig" :actions="actions" :loading="starter.loading" :filter="false" elevation="0" show-actions></item-list>
                            </v-flex>
                            <v-flex xl11 sm10 xs12 v-show="!starter.add_registration && starter.starter_registrations.length === 0">
                                <h3>Für diesen Starter ist noch keine Meldung vorhanden. Klicke auf "Meldung hinzufügen", um den Starter zu einer Startklasse anzumelden.</h3>
                            </v-flex>
                            <v-flex class="hidden-xs-only" xl1 sm2 v-show="!starter.add_registration && starter.starter_registrations.length === 0">
                                <v-icon class="mr-4 rotate" large color="black" style="float: right;">subdirectory_arrow_right</v-icon>
                            </v-flex>
                            <v-flex xs12 v-if="starter.add_registration">
                                <starter-registration :starter.sync="starter" @cancel="$set(starter, 'add_registration', false)" @submit="starterRegistrationSaved"></starter-registration>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <!--v-card-title(v-if="!starter.add_registration")-->
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import StarterRegistration from '../StarterRegistration';
    import ItemList from '../../../components/common/ItemList';

    export default {
        components: {
            StarterRegistration,
            ItemList
        },
        props: {
            event: {
                type: Object,
                default:  null
            },
            starters: {
                type: Array,
                default:  () => []
            }
        },
        data() {
            return {
                loading: false,
                registrations: [],
                dataTableConfig: {
                    loadingDataText: 'Keine Meldungen vorhanden',
                    noDataText: 'Keine Meldungen vorhanden',
                    rowsPerPageText: 'Zeilen pro Seite',
                    headers: [
                        {text: 'Typ', value: 'starter_type.name', align: 'left', translate: true},
                        {text: 'Altersklasse', value: 'age_group.name', align: 'left'},
                        {text: 'Style', value: 'starter_style.name', align: 'left'},
                        {text: 'Preis', value: 'price_string', align: 'left'}
                    ],
                    items: {
                        large: [
                            {value: 'starter_type.name', translate: true},
                            {value: 'age_group.name'},
                            {value: 'starter_style.name'},
                            {value: 'price_string'}
                        ],
                        small: [
                            {value: 'starter_type.name', translate: true},
                            {value: 'age_group.name'},
                            {value: 'starter_style.name'},
                            {value: 'price_string'}
                        ]
                    }
                },
                actions: [
                    {
                        label: this.$t('details'),
                        icon: 'info',
                        disabled: registration => (registration.hasOwnProperty('deleting') && registration.deleting) || this.loading,
                        click: this.registrationInfo
                    },
                    {
                        label: this.$t('delete'),
                        icon: 'delete',
                        loading: registration => registration.hasOwnProperty('deleting') && registration.deleting,
                        disabled: registration => (registration.hasOwnProperty('deleting') && registration.deleting) || this.loading,
                        click: this.deleteRegistration
                    }
                ],
                cancelRequest: null
            }
        },
        methods: {
            starterRegistrationSaved(starter) {
                this.$set(starter, 'add_registration', false);

                let index = -1;
                this.starters.forEach((item, _id) => {
                    if (starter.id === item.id) {
                        index = _id;
                        return false;
                    }
                });

                if (index > -1) {
                    let starters = _.cloneDeep(this.starters);
                    starters[index] = starter;

                    this.$emit('update:starters', starters);
                }
            },
            registrationInfo(registration) {
                let starter = _.find(this.starters, s => s.id === registration.starter_id);
                let html = '<table style="width: 100%"><thead><tr><th class="text-xs-left">Tänzer*in</th><th class="text-xs-right">Startgebühr</th></tr></thead><tbody>';

                _.each(registration.starter_member_registrations, smr => {
                    let startingOrder = 'Erststart';
                    if (smr.price_reduced) {
                        startingOrder = 'Zweitstart';
                    }
                    html += `<tr><td>${smr.starter_member.full_name} (${startingOrder})</td><td class="text-xs-right">${this.$currency(smr.price)}</td></tr>`;
                });

                html += `<tr><td><b>Gesamt:</b></td><td class="text-xs-right"><b>${this.$currency(registration.price)}</b></td></tr></tbody></table>`;

                this.$store.commit('info', {
                    headline: `${starter.name} - ${registration.age_group.name}` + (registration.starter_style ? ` - ${registration.starter_style.name}` : ''),
                    text: html
                });
            },
            deleteRegistration(registration) {
                this.$set(registration, 'deleting', true);

                let index = -1;
                let starter = null;
                this.starters.forEach(item => {
                    item.starter_registrations.forEach((r, _id) => {
                        if (r.id === registration.id) {
                            index = _id;
                            starter = item;
                            return false;
                        }
                    });

                    if (starter) {
                        return false;
                    }
                });

                this.$set(starter, 'loading', true);

                axios.delete(`/api/v1/starter_registrations/${registration.id}`).then(response => {


                    if (starter.starter_registrations.length === 1) {
                        axios.delete(`/api/v1/starters/${starter.id}`).then(response => {
                            if (!response.data.success) {
                                return;
                            }

                            if (index > -1) {
                                starter.starter_registrations.splice(index, 1);
                            }

                            this.$emit('starterRegistrationDeleted');
                            this.$set(starter, 'loading', false);
                        });
                    } else {
                        if (index > -1) {
                            starter.starter_registrations.splice(index, 1);
                        }

                        this.$emit('starterRegistrationDeleted');
                        this.$set(starter, 'loading', false);
                    }
                });
            }
        }
    }
</script>

<style>
    .rotate {
        -webkit-transform: rotate(-90deg);
        -moz-transform: rotate(-90deg);
        -ms-transform: rotate(-90deg);
        -o-transform: rotate(-90deg);
        transform: rotate(-90deg);
    }
</style>